const selectors = {
  item: '[data-row]',
  question: '[data-body-tab-question]',
};

const initFaqItemAccordion = () => {
  const faqItems: NodeListOf<HTMLElement> = document.querySelectorAll(
    selectors.item,
  );

  if (!faqItems?.length) return;

  faqItems.forEach((item) => {
    const question = item.querySelector(selectors.question);
    if (!question) return;

    question.addEventListener('click', () => {
      const isOpen = item.dataset.open === 'true';
      item.dataset.open = String(!isOpen);
    });
  });
};

document.addEventListener('DOMContentLoaded', initFaqItemAccordion);
